import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=cfea9f24&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=cfea9f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfea9f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfea9f24')) {
      api.createRecord('cfea9f24', component.options)
    } else {
      api.reload('cfea9f24', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=cfea9f24&scoped=true&", function () {
      api.rerender('cfea9f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R9Yl4BeyUCTb/JS/comp/GuestBox.vue"
export default component.exports